import React, { useState, useEffect } from 'react';
import { FormGroup, Spinner, Form, Row, Col, Input, Button } from 'reactstrap';
import Select from 'react-select';
import { useForm } from 'react-hook-form';

//Api
import formulariovistoria_api from '../../../../api/formulariovistoria_api';
import contrato_api from '../../../../api/contrato_api';

//Helpers
import { showMessage } from 'helpers/message';


export default function ConfiguracaoFiscalizacao({ contrato, set_contrato, loadContrato }) {
    const { register, errors, handleSubmit, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

    //Estado de controle dos formularios
    const [formularios, set_formularios] = useState([]);

    //Estado de controle das opções dos formularios
    const [options_formularios, set_options_formularios] = useState([]);

    //Função de onChange do campo de formularios
    const handleChangeFormularios = (value) => {
        let _formularios = [];
        if (value)
            value.map(m => {
                _formularios.push(m.value);
            });
        set_formularios(_formularios);
    }

    const options_periodo_fiscalizacao = [
        { value: 'Mensal', label: 'Mensal' },
        { value: 'Bimestral', label: 'Bimestral' },
        { value: 'Trimestral', label: 'Trimestral' },
        { value: 'Quadrimestral', label: 'Quadrimestral' },
        { value: 'Semestral', label: 'Semestral' },
        { value: 'Anual', label: 'Anual' }
    ];
    const [periodoFiscalizacao, set_periodoFiscalizacao] = useState("");

    const handleChangePeriodoFiscalizacao = (value) => {
        clearErrors("periodoFiscalizacao");
        set_periodoFiscalizacao(value);
        setValue("periodoFiscalizacao", value, true);
    }

    //Estado de controle do loading na tela
    const [show_loading, set_show_loading] = useState(false);

    //Função de envio dos dados dos formularios
    const onSubmit = (data) => {

        const json_submit = {
            ...data
        }
        json_submit.formularioVistorias_Ids = [...formularios];
        json_submit.contrato_Id = contrato.contrato_Id;
        console.log(json_submit)
        set_show_loading(true);
        contrato_api.configuracaoFiscalizacao(json_submit).then(response => {
            if (response.status !== 204) {
                showMessage("Aviso", response.message, 'error', null);
            }
            else {
                showMessage("Sucesso!", response.message, 'success', null);
                loadContrato();
            }
        }).finally(f => set_show_loading(false));

    }

    //Função de carregar os formularios
    const loadFormularios = () => {
        set_show_loading(true);
        formulariovistoria_api.getAll().then(response => {
            if (response.status !== 200) {
                showMessage("Aviso", response.message, 'error', null);
            }
            else {
                set_options_formularios(response.data.map(value => ({ value: value.formularioVistoria_Id, label: value.identificacao })));
            }
        }).finally(f => set_show_loading(false));
    }

    //Função que carrega os campos
    const setValues = () => {
        setValue("numeroMinimoVistorias", contrato.numeroMinimoVistorias);
        setValue("periodoFiscalizacao", contrato.periodoFiscalizacao);
        set_periodoFiscalizacao(contrato.periodoFiscalizacao);
        set_formularios(contrato.formularioVistoria_Ids);
    }
    useEffect(() => {
        loadFormularios();
        setValues();
    }, []);

    return (
        <div>
            {show_loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md="12" lg="12">
                        <FormGroup>
                            <label className="form-control-label">Lista de Formulários</label>
                            <Select
                                name="formularioVistorias_Ids"
                                options={options_formularios}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                onChange={(o) => handleChangeFormularios(o)}
                                value={options_formularios.filter((value) => formularios.filter(f => f == value.value).length > 0)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                isMulti={true}
                                ref={e => register(
                                    { name: "formularioVistorias_Ids" },
                                    { required: false })
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12" lg="4">
                        <FormGroup>
                            <label className="form-control-label">Número mínimo de vistorias no período</label>
                            <Input className="form-control"
                                autocomplete="off"
                                type="text"
                                name="numeroMinimoVistorias"
                                innerRef={register({ required: true })}
                            />
                            {errors.numeroMinimoVistorias && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col md="12" lg="4">
                        <FormGroup>
                            <label className="form-control-label">Período Fiscalização</label>
                            <Select
                                name="periodoFiscalizacao"
                                options={options_periodo_fiscalizacao}
                                getOptionLabel={o => o.label}
                                getOptionValue={o => o.value}
                                value={options_periodo_fiscalizacao.filter(f => f.value === periodoFiscalizacao)}
                                onChange={(o) => handleChangePeriodoFiscalizacao(o.value)}
                                classNamePrefix="select"
                                placeholder="[ Selecione ]"
                                ref={e => register(
                                    { name: "periodoFiscalizacao" },
                                    { required: true })
                                }
                            />
                            {errors.periodoFiscalizacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                    </Col>
                    <Col lg="12" md="12" sm="12" className="text-center">
                        <Button color="success" type="submit">
                            <i className="fas fa-save"></i>  Salvar
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}